import jsPDF from 'jspdf';

/*
 * Escala de render de html2canvas. Antes era `Math.min(3, devicePixelRatio * 2)`,
 * así que el informe salía a distinta resolución según la pantalla de quien lo
 * descargaba. 3 es la variante más nítida de las que se producían.
 *
 * El informe de sweeper-car renderiza su propio canvas a 1.5 (`CANVAS_SCALE` en
 * modal-node-details.component.ts) deliberadamente y no importa esta constante:
 * cambiar este valor no afecta a ese informe.
 */
export const PDF_RENDER_SCALE = 3;

/*
 * Medido offline contra el PNG anterior, sobre el maquetado y CSS reales del
 * informe: ambas imágenes se remuestrearon a una rejilla común de 150 dpi sobre
 * los 188 mm de ancho útil del A4 para calcular el PSNR (esa rejilla es la de
 * la comparación, no la resolución de salida). Resultado: 58,6 dB de PSNR y un
 * 0,003 % de subpíxeles con diferencia mayor que 8; revisado también a ojo con
 * zoom 4× sobre texto de 16 px a resolución nativa.
 */
export const PDF_IMAGE_QUALITY = 0.92;

export const PDF_IMAGE_FORMAT = 'JPEG';

/*
 * jsPDF detecta el formato de la imagen por los magic bytes de los datos y sólo
 * recurre al formato pasado como parámetro si el sniffing falla, así que este
 * valor no es la protección real contra volver a incrustar PNG sin comprimir:
 * si `canvasToPdfImage` volviera a generar PNG, jsPDF lo enrutaría a su decoder
 * de PNG igualmente. La protección real es `compress: true` en el documento
 * (ver `createReportPdf`): eso obliga a jsPDF a deflatar los píxeles en vez de
 * guardarlos crudos si el formato detectado no es ya un formato comprimido como
 * JPEG. De ahí venían los ~37 MB por página.
 */
export function canvasToPdfImage(canvas: HTMLCanvasElement): string {
  return canvas.toDataURL('image/jpeg', PDF_IMAGE_QUALITY);
}

export function createReportPdf(): jsPDF {
  return new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4', compress: true });
}
